import { api } from 'boot/axios.js'

export async function query(ctx, queryParams = {}) {
  try {
    const response = await api({
      url: '/requests',
      params: queryParams,
      method: 'GET'
    })
    ctx.commit('items', response.data.items)
    return response
  } catch (e) {
    throw e
  }
}

export async function get(ctx, queryParams = {}) {
  try {
    const response = await api({
      url: parseUrl('requests', queryParams),
      params: queryParams,
      method: 'GET'
    })
    ctx.commit('item', response.data)
    return response
  } catch (e) {
    throw e
  }
}

export async function createRequest(ctx, data) {
  try {
    const response = await api({
      url: '/requests',
      method: 'POST',
      data: data
    })
    return response
  } catch (e) {
    throw e
  }
}

export async function upload(ctx, data) {
  try {
    const response = await api({
      url: '/quotes',
      method: 'POST',
      data: data
    })
    return response
  } catch (e) {
    throw e
  }
}

function parseUrl(state, params) {
  if (state && params.id) {
    return `/${state}/${params.id}`
  }
  return `/${state}`
}